var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuessControle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.405,
    height: 18,
    viewBox: "0 0 14.405 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26908",
    "data-name": "Trac\\xE9 26908",
    d: "M22.071,5.485a.9.9,0,0,0-.756-.18,7.187,7.187,0,0,1-5.6-1.143.894.894,0,0,0-1.026,0,7.187,7.187,0,0,1-5.6,1.143A.9.9,0,0,0,8,6.188v6.707a8.111,8.111,0,0,0,3.394,6.6l3.286,2.341a.907.907,0,0,0,1.044,0l3.286-2.341a8.111,8.111,0,0,0,3.394-6.6V6.188A.9.9,0,0,0,22.071,5.485ZM20.6,12.895a6.308,6.308,0,0,1-2.638,5.132L15.2,20l-2.764-1.972A6.308,6.308,0,0,1,9.8,12.895V7.223a8.99,8.99,0,0,0,5.4-1.251,8.99,8.99,0,0,0,5.4,1.251Zm-4.015-2.062-2.422,2.431-.8-.81a.9.9,0,0,0-1.278,1.278l1.44,1.44a.9.9,0,0,0,1.278,0l3.1-3.07a.9.9,0,0,0-1.278-1.278Z",
    transform: "translate(-8 -4)",
    fill: "#6f7070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuessControle);
export default __webpack_public_path__ + "static/media/quess_controle.08a42cac1a454aee5c4e058cd25b4167.svg";
export { ForwardRef as ReactComponent };